import React from 'react';
import { Button } from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useParams } from 'react-router-dom';
import { ParentAdminTableFormProps } from 'src/components/enterprise/Parents/Admin/ParentAdminsController/types';
import { useSendWelcomeEmailParentAdmins } from 'src/components/enterprise/Parents/Admin/hooks/useSendWelcomeEmailParentAdmins/useSendWelcomeEmailParentAdmins';

export const EmailParentAdminsButton: React.FC = () => {
  const { watch, setValue } = useFormContext<ParentAdminTableFormProps>();
  const { corpid: corpId } = useParams<{ corpid: string }>();

  const selectedParentAdminIds = watch('selectedParentAdminIds');

  const { isLoading, sendEmail } = useSendWelcomeEmailParentAdmins({
    corpId,
    onSuccess: () => {
      setValue('selectedParentAdminIds', []);
    },
  });

  const handleSendEmail = () => {
    sendEmail(selectedParentAdminIds);
  };

  return (
    <Button
      variant="secondary"
      disabled={selectedParentAdminIds.length === 0 || isLoading}
      onClick={handleSendEmail}
    >
      Email parent admins
    </Button>
  );
};
